import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Grid from '../../../components/Grid/Grid';
import Button from '../../../components/Button/Button';
import PowderBatchTemperatureCreateDialog from './PowderBatchTemperatureCreateDialog';

const PowderBatchTemperatureTableToolbar = ({ onAddPowderBatchTemperatureSuccess }) => {
  const [isAddingPowderBatchTemperatureOpen, setIsAddingPowderBatchTemperatureOpen] =
    useState(false);

  const handleAddingPowderBatchTemperatureOpen = (e) => {
    e.preventDefault();
    setIsAddingPowderBatchTemperatureOpen(true);
  };

  return (
    <div>
      <div>
        <Toolbar>
          <Grid
            container
            style={{ marginTop: 25, marginBottom: 20, width: '100%' }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid xs={6}>
              <Button
                variant="outlined"
                color="primary"
                rounded
                startIcon={<AddIcon />}
                onClick={handleAddingPowderBatchTemperatureOpen}
              >
                新增一項
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </div>
      <PowderBatchTemperatureCreateDialog
        isOpen={isAddingPowderBatchTemperatureOpen}
        onClose={() => setIsAddingPowderBatchTemperatureOpen(false)}
        onSubmitSuccess={onAddPowderBatchTemperatureSuccess}
      />
    </div>
  );
}; // TransferDetectTypeTableToolbar

PowderBatchTemperatureTableToolbar.propTypes = {
  onAddPowderBatchTemperatureSuccess: PropTypes.func.isRequired,
};

export default PowderBatchTemperatureTableToolbar;
